var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import createBreakpoints from "./create-breakpoints.js";
import createColorSchemes from "./create-color-schemes.js";
import createShadow from "./create-shadow.js";
import createSize from "./create-size.js";
import createSpacing from "./create-spacing.js";
import createTypography from "./create-typography.js";
export function createTheme(override = {}) {
    const { breakpoints, outline, schemes, shadow, spacing, typography } = override, other = __rest(override, ["breakpoints", "outline", "schemes", "shadow", "spacing", "typography"]);
    return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, createBreakpoints(breakpoints)), createColorSchemes(schemes)), createShadow(shadow, outline)), createTypography(typography)), { size: createSize(), spacing: createSpacing(spacing), 
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        palette: (() => { }) }), other);
}
export default createTheme;
//# sourceMappingURL=create-theme.js.map